import React from 'react';
import { ReferenceAsset } from '../types';
import { Upload, Edit2, Trash2, Tag, Check, X } from 'lucide-react';

interface AssetItemProps {
  asset: ReferenceAsset;
  isEditing: boolean;
  editForm: any;
  setEditForm: (v: any) => void;
  startEditing: (e: React.MouseEvent, asset: ReferenceAsset) => void;
  saveEditing: (id: string) => void;
  cancelEditing: () => void;
  removeAsset: (e: React.MouseEvent, id: string) => void;
  getTypeLabel: (t: string) => string;
  triggerFileInput: () => void;
}

export const AssetItem: React.FC<AssetItemProps> = ({
  asset, isEditing, editForm, setEditForm, startEditing, saveEditing, cancelEditing, removeAsset, getTypeLabel, triggerFileInput
}) => {
  const displayUrl = isEditing && editForm.url ? editForm.url : asset.url;
  return (
    <div className={`group relative bg-slate-800 rounded-md overflow-hidden border shadow-sm transition-all ${isEditing ? 'border-indigo-500 ring-1 ring-indigo-500' : 'border-slate-700 hover:border-indigo-500'}`}>
        <div className="relative h-32 bg-slate-950 group">
            <img src={displayUrl} alt={asset.name} className={`w-full h-full object-cover transition-opacity ${isEditing ? 'opacity-50' : 'opacity-90 group-hover:opacity-100'}`} />
            {isEditing && (
                <div className="absolute inset-0 flex items-center justify-center cursor-pointer hover:bg-black/20" onClick={triggerFileInput}>
                    <div className="bg-slate-900/80 text-indigo-300 px-3 py-1.5 rounded-full text-xs font-bold flex items-center gap-2 shadow-lg hover:bg-slate-800 hover:text-white transition-colors"><Upload size={12} /> 替换</div>
                </div>
            )}
            {!isEditing && (
                <>
                <div className="absolute top-1 right-1 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                    <button onClick={(e) => startEditing(e, asset)} className="bg-slate-900/90 p-1.5 rounded text-indigo-400 hover:text-white hover:bg-indigo-600 transition-colors shadow-sm"><Edit2 size={12} /></button>
                    <button onClick={(e) => removeAsset(e, asset.id)} className="bg-slate-900/90 p-1.5 rounded text-red-400 hover:text-white hover:bg-red-600 transition-colors shadow-sm"><Trash2 size={12} /></button>
                </div>
                <div className="absolute bottom-1 left-1 pointer-events-none"><span className={`text-[9px] px-1.5 py-0.5 rounded uppercase font-bold text-white/90 shadow-sm ${asset.type === 'character' ? 'bg-indigo-500' : asset.type === 'scene' ? 'bg-emerald-500' : asset.type === 'prop' ? 'bg-orange-500' : 'bg-slate-600'}`}>{getTypeLabel(asset.type)}</span></div>
                </>
            )}
        </div>
        <div className="p-2.5">
        {isEditing ? (
            <div className="space-y-2">
                <input type="text" value={editForm.name} onChange={e => setEditForm({...editForm, name: e.target.value})} className="w-full bg-slate-900 border border-slate-600 rounded px-2 py-1 text-xs text-white focus:border-indigo-500 outline-none" placeholder="名称" />
                <div className="flex gap-1">
                    {['character', 'scene', 'prop', 'style'].map(t => (
                        <button key={t} onClick={() => setEditForm({...editForm, type: t})} className={`flex-1 py-1 text-[8px] uppercase rounded border ${editForm.type === t ? 'bg-slate-700 border-indigo-400 text-white' : 'border-slate-700 text-slate-500 hover:bg-slate-800'}`}>{getTypeLabel(t)}</button>
                    ))}
                </div>
                <div className="relative">
                    <Tag size={10} className="absolute left-2 top-2 text-slate-500" />
                    <input type="text" value={editForm.keywords} onChange={e => setEditForm({...editForm, keywords: e.target.value})} className="w-full bg-slate-900 border border-slate-600 rounded pl-6 pr-2 py-1 text-xs text-emerald-300 focus:border-emerald-500 outline-none" placeholder="关键词 (A|B)" />
                </div>
                <div className="flex gap-2 pt-1">
                    <button onClick={() => saveEditing(asset.id)} className="flex-1 bg-indigo-600 hover:bg-indigo-500 text-white text-[10px] py-1 rounded flex items-center justify-center gap-1"><Check size={10} /> 保存</button>
                    <button onClick={cancelEditing} className="flex-1 bg-slate-700 hover:bg-slate-600 text-slate-300 text-[10px] py-1 rounded flex items-center justify-center gap-1"><X size={10} /> 取消</button>
                </div>
            </div>
        ) : (
            <>
                <div className="flex items-start justify-between gap-2"><p className="text-xs font-bold text-slate-200 truncate cursor-default" title={asset.name}>{asset.name}</p></div>
                <div className="mt-1.5 flex flex-wrap gap-1">
                    {asset.keywords ? asset.keywords.split('|').map((k:string, i:number) => <span key={i} className="px-1.5 py-0.5 bg-indigo-500/10 text-indigo-300 border border-indigo-500/20 rounded-[3px] text-[9px] truncate max-w-full cursor-default">{k.trim()}</span>) : <span className="text-[9px] text-slate-600 italic">无关键词</span>}
                </div>
            </>
        )}
        </div>
    </div>
  );
};